/// app.js
import React from 'react';
import DeckGL from '@deck.gl/react';
import {ScatterplotLayer} from '@deck.gl/layers';
import {StaticMap} from 'react-map-gl';
import {HeatmapLayer} from '@deck.gl/aggregation-layers';
import sourceData from './database.json';

// Set your mapbox access token here
const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoibGxpYW1tY2JlYW4iLCJhIjoiY2toZmM3amgyMG8wejJzcXBhMXZrZmNobiJ9.RU-E8O0uVhJUEPx92MHVlA';


console.log(sourceData);

// Viewport settings
const INITIAL_VIEW_STATE = {
  container: 'map',
  style: 'mapbox://styles/mapbox/dark-v10',
  longitude: -98.5795,
  latitude: 39.8283,
  zoom: 4,
  pitch: 90,
  bearing: 0
};

function App() {
  const layers = [
    new ScatterplotLayer({
      id: 'scatter',
      data: sourceData,
      opacity: 0.8,
      filled: true,
      radiusMinPixels: 10,
      radiusMaxPixels: 4,
      getPosition: d => [d["Accident Longitude"], d["Accident Latitude"]],
      getFillColor: d => d["Net Loss (Barrels)"] > 100 ? [200, 0, 40, 150] : [255, 140, 0, 100],
      pickable: true,
      onHover: ({object, x, y}) => {
          const el = document.getElementById('tooltip');
          if (object) {
            el.innerHTML = `<h1>${object["Operator Name"]}</h1>
            <p>${object[["Net Loss (Barrels)"]]} Barrels</p>
            <p>${object[["All Costs"]]} USD</p>`
            el.style.display = 'block';
            el.style.opacity = 0.9;
            el.style.left = x + 'px';
            el.style.top = y + 'px';
          } else {
            el.style.opacity = 0.0;
          }
      }
    }),
    new HeatmapLayer({
      id: 'heat',
      data: sourceData,
      opacity: 0.5,
      getPosition: d => [d["Accident Longitude"], d["Accident Latitude"]],
      getWeight: d => d["Net Loss (Barrels)"] + (d["Net Loss (Barrels)"] * 0.5),
      radiusPixels: 60,
    })
  ];

  return (
    <DeckGL
      initialViewState={INITIAL_VIEW_STATE}
      controller={true}
      layers={layers}
    >
      <StaticMap mapboxApiAccessToken={MAPBOX_ACCESS_TOKEN} mapStyle='mapbox://styles/lliammcbean/ckhffmdvc0g541apg2xrbxpgb'/>
    </DeckGL>
  );
}

export default App;
